export default __webpack_public_path__ + "static/KanvasDesigner-e3bbc66d72dedf1345a87890103e31c0.webp";